import { classNames } from "primereact/utils";
import React, { useEffect, useRef, useState } from "react";
import "./TruncatedText.scss";

type TruncatedTextTag = "span" | "p" | "h4";

type TruncatedTextProps = {
    text?: string | null;
    className?: string;
    lines?: number;
    as?: TruncatedTextTag;
};

const TruncatedText: React.FC<TruncatedTextProps> = ({
    text,
    className,
    lines = 1,
    as: Tag = "span",
}) => {
    const ref = useRef<HTMLElement>(null);
    const [truncated, setTruncated] = useState(false);
    const content = text?.trim() || "";

    useEffect(() => {
        const element = ref.current;
        if (!element) {
            return;
        }

        const updateTruncation = () => {
            if (lines <= 1) {
                setTruncated(element.scrollWidth > element.clientWidth + 1);
                return;
            }
            setTruncated(element.scrollHeight > element.clientHeight + 1);
        };

        updateTruncation();
        const observer = new ResizeObserver(updateTruncation);
        observer.observe(element);

        return () => observer.disconnect();
    }, [content, lines]);

    return (
        <Tag
            ref={ref as React.Ref<HTMLHeadingElement & HTMLParagraphElement & HTMLSpanElement>}
            className={classNames(
                "truncated-text",
                lines > 1 && "truncated-text--multiline",
                className,
            )}
            style={lines > 1 ? ({ WebkitLineClamp: lines } as React.CSSProperties) : undefined}
            title={truncated && content ? content : undefined}
        >
            {content || "\u00A0"}
        </Tag>
    );
};

export default TruncatedText;
